import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
	const router = useRouter()
	const config = useRuntimeConfig()

	const pluginEnabled = (config.public.environment === 'production') ? true : false

	nuxtApp.vueApp.use(createGtm({
		id: config.public.gtmId,
		defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
		compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
		nonce: '00-so-98879066', // Will add `nonce` to the script tag
		enabled: pluginEnabled, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
		debug: false, // Whether or not display console logs debugs (optional)
		loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
		vueRouter: router, // Pass the router instance to automatically sync with router (optional)
		//ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
		trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
	}))
})
